import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import {GRAY_DARKER} from 'ui-library/Colors';
import ErrorMessage from 'ui-library/ErrorMessage';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import TextField from 'ui-library/inputs/TextField';

import {MeltTransform} from '../../RunSchemaSpecConstants';
import {
  CSVTextAreaInput,
  getColumnNamesFromInput,
  MeltFormErrors,
  updateTransformationProperties,
} from './TransformFormUtils';

interface MeltFormProps {
  transform: MeltTransform;
  onChange: (transform: MeltTransform) => void;
  formErrors: MeltFormErrors;
}
export default function MeltForm(props: MeltFormProps): JSX.Element {
  return (
    <>
      <Row>
        <Col md={6}>
          <FieldLabel label="Identifier column(s)" labelStyle={LabelStyle.LABEL} isRequired={true} />
          <CSVTextAreaInput
            value={props.transform.transformationProperties?.identifierColumns}
            placeholder="Sample ID, Concentration"
            parseCSVInputFn={getColumnNamesFromInput}
            onChange={(value: Array<string>) => {
              props.onChange(updateTransformationProperties(props.transform, 'identifierColumns', value));
            }}
            hasError={props.formErrors.identifierColumns}
          />
          {props.formErrors.identifierColumns ? (
            <ErrorMessage error="Identifier column(s) are required and must not contain duplicates" />
          ) : null}
          <div className={css(styles.description)}>
            Enter a list of column(s) that identify the variable/value combinations, separated by comma.
          </div>
        </Col>
        <Col md={6}>
          <FieldLabel label="Value columns" labelStyle={LabelStyle.LABEL} />
          <CSVTextAreaInput
            value={props.transform.transformationProperties?.valueColumns}
            placeholder="Sample ID, Concentration"
            parseCSVInputFn={getColumnNamesFromInput}
            onChange={(value: Array<string>) => {
              if (value.length === 0) {
                const {valueColumns, ...newTransformationProperties} =
                  props.transform.transformationProperties;
                props.onChange({
                  ...props.transform,
                  transformationProperties: newTransformationProperties,
                });
              } else {
                props.onChange(updateTransformationProperties(props.transform, 'valueColumns', value));
              }
            }}
            hasError={props.formErrors.valueColumns}
          />
          {props.formErrors.valueColumns ? (
            <ErrorMessage error="Value columns must not contain duplicates" />
          ) : null}
          <div className={css(styles.description)}>
            Columns to un-pivot. Enter a list of column(s), separated by comma. Leave blank to use all
            columns.
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <TextField
            label="New variable column name"
            onChange={(e) => {
              props.onChange(
                updateTransformationProperties(props.transform, 'newVariableColumn', e.target.value)
              );
            }}
            labelStyle={FieldLabel.STYLES.LABEL}
            isRequired={true}
            value={props.transform.transformationProperties?.newVariableColumn || 'variable'}
          />
        </Col>
        <Col md={6}>
          <TextField
            label="New value column name"
            onChange={(e) => {
              props.onChange(
                updateTransformationProperties(props.transform, 'newValueColumn', e.target.value)
              );
            }}
            labelStyle={FieldLabel.STYLES.LABEL}
            isRequired={true}
            value={props.transform.transformationProperties?.newValueColumn || 'value'}
          />
        </Col>
      </Row>
    </>
  );
}

const styles = StyleSheet.create({
  description: {
    fontSize: 13,
    lineHeight: '16px',
    color: GRAY_DARKER,
    paddingTop: '7px',
    paddingBottom: '16px',
  },
});
